// 常夜燈の光の粒 = ゲームのどこで出ても同じ色・同じ大きさの1粒 (2026-10-31 作者の答え・正本はここ1か所)。
//   作者 (10-31・介錯の咆哮の答えるページ 1JX68V9HqZ7REahFkqhuMG のメモ)「集まっている光の粒が常夜燈の色になっていない\nあと、常夜燈の光の1つあたりの大きさは統一して。ゲームのあらゆるところで大きさが違う」
//   色 = 常夜燈そのもの (render.ts drawGhostLight の cool・普段の致命の光 src/luna_lamp_leak_fx.ts の LAMP と同じ 3 色・10-20 から配布版で作者に通っている)。
//     芯は小さな青白い点、そのまわりを常夜燈の青のにじみが包む (芯だけだと加算で白い点に見える = 10-30 の咆哮の粒の失敗)。
//   大きさ = 芯の半径 1.8px・にじみの半径 9px (画面 960x540 上・カメラの寄りは別)。どこでも同じで、粒ごとに変えない。濃さ (a) だけを場面が決める。
//   使う所: 介錯の咆哮の溜めで集まる粒 (render.ts drawRoarFxBehind)・プロローグの漂い (adv_air_view.ts)・
//     普段の致命でひびから昇る光 (luna_lamp_leak_fx.ts)・一突きの版の昇る粒 (luna_pierce_fx.ts・開発版)・軍配者の装置が現れる時に浮かぶ光 (twins_fight_draw.ts)。
//   使わない所 (別の色の役): ボスからほどける光・魂・死の浄化 = SOUL_BLUE (常夜燈より白い・10-11)。光の塊・にじみ (粒でない物) もここでは決めない。
//   前の版 (場所ごとに色と大きさが違う) = DEV ?lampMote=old。
export type LampRgb = readonly [number, number, number]
export const LAMP_MOTE = {
  core: [214, 234, 255] as LampRgb,
  mid: [170, 205, 255] as LampRgb,
  deep: [96, 142, 228] as LampRgb,
  coreR: 1.8,
  haloR: 9,
} as const

let old = false
export function setLampMoteLook(v: string | null): void { old = v === 'old' }
/** 前の版 (場所ごとの色と大きさ) を描くか (DEV ?lampMote=old)。 */
export function lampMoteOld(): boolean { return old }

const c = (rgb: LampRgb, a: number): string => `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${Math.max(0, Math.min(1, a)).toFixed(3)})`

/** 常夜燈の光の1粒。a = 濃さ 0..1。加算 ('lighter') で重ねる前提 (呼ぶ側が合成を決める)。 */
export function drawLampMote(ctx: CanvasRenderingContext2D, x: number, y: number, a: number): void {
  if (a <= 0.01) return
  const R = LAMP_MOTE.haloR
  const g = ctx.createRadialGradient(x, y, 0, x, y, R)
  g.addColorStop(0, c(LAMP_MOTE.mid, a * 0.9))
  g.addColorStop(0.35, c(LAMP_MOTE.deep, a * 0.45))
  g.addColorStop(1, c(LAMP_MOTE.deep, 0))
  ctx.fillStyle = g
  ctx.fillRect(x - R, y - R, R * 2, R * 2)
  ctx.fillStyle = c(LAMP_MOTE.core, a * 0.95)
  ctx.beginPath(); ctx.arc(x, y, LAMP_MOTE.coreR, 0, Math.PI * 2); ctx.fill()
}
